import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getMeals = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/meals', {
        params,
        withCredentials: true
    });
    return res;
}

export const createMeal = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/meals',
    createObj,
    {
        withCredentials: true,
        successMessage: "Meal ได้ถูกสร้างแล้ว"
    });
    return res;
}

export const updateMeal = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/meals/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "Meal ได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteMeal = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/meals/${id}`,
    {
        withCredentials: true,
        successMessage: "Meal ได้ถูก Reactivate แล้ว"
    });
    return res;
}

export const restoreMeal = async (id) => {
    const res = await axios.post(BACKEND_URL+`/meals/${id}/restore`,
    {},
    {
        withCredentials: true,
        successMessage: "Meal ได้ถูก Activate แล้ว"
    });
    return res;
}
